import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';
import s from './SplashPage.module.css';

const WORD = 'Сквозь';
const letters = WORD.split('');

interface Props {
  onEnter: () => void;
}

export function SplashPage({ onEnter }: Props) {
  const [lit, setLit] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLit(true), letters.length * 90 + 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={s.screen} onClick={onEnter}>
      <div className={s.glow} />

      <div className={s.center}>
        <div className={s.wordmark}>
          {/* base neon word */}
          <div className={s.letters}>
            {letters.map((ch, i) => (
              <span
                key={i}
                className={s.letter}
                style={{ animationDelay: `${i * 0.09}s` }}
              >
                {ch}
              </span>
            ))}
          </div>

          {/* light wave through the letters */}
          {lit && (
            <div aria-hidden className={s.wave}>
              {letters.map((ch, i) => (
                <span key={i} className={s.waveLetter}>{ch}</span>
              ))}
            </div>
          )}

          {/* bright streak */}
          {lit && <div aria-hidden className={s.streak} />}
        </div>

        <div className={s.tagline}>Слово-маршрут за 90 секунд</div>
      </div>

      <div className={s.cta}>
        <Button
          variant="primary"
          style={{ maxWidth: 260, width: '100%' }}
          onClick={(e) => { e.stopPropagation(); onEnter(); }}
        >
          Начать
        </Button>
        <div className={s.hint}>нажми, чтобы войти</div>
      </div>
    </div>
  );
}
